
        var result = require("!!../../../node_modules/css-loader/index.js!./header.component.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/header/header.component.css
// module id = 724
// module chunks = 0